import { HashElement } from "@context/map/units/unitsStore";
import { KAryTreeNode } from "@baseTypes/baseType";

export interface AsMap<T extends HashElement> extends  Map<string, KAryTreeNode<T>>{}

export interface AsObjectHashMap<T extends HashElement> {
    [k: string]: T
}

type FoldFn<Z, T> = (acc: Z, data: KAryTreeNode<T>, parent?: KAryTreeNode<T>) => [Z, KAryTreeNode<T> | undefined]

export function traverseTree<T>(root: KAryTreeNode<T>, accumulator: (value: KAryTreeNode<T>, parentNode?: KAryTreeNode<T>) => void): void {
    accumulator(root);
    for (const child of root.data || [])
        traverseTree(child, (v, _) =>
            accumulator(v, child));
}

export const foldTreeNodes = <T extends HashElement, Z>(initial: Z) => (root: KAryTreeNode<T>, processNode: FoldFn<Z, T>): Z => {
    const traverse = ([[node, parent] = [undefined, undefined], ...xs]: [n?: KAryTreeNode<T>, p?:KAryTreeNode<T>][], acc: Z): Z => {
        if (node) {
            const next = node.data || []
            const [a, parentNode] = processNode(acc, node, parent)
            return traverse(next.map(node => [node, parentNode]).concat(xs) as [KAryTreeNode<T>, KAryTreeNode<T>][], a)
        } else return acc
    }
    return traverse([[root, root]], initial)
}

// export function groupByTree<T extends HashElement, K extends keyof T>(root: KAryTreeNode<T>, groupBy: (data: KAryTreeNode<T>) => K):  AsObjectHashMap<T> {
//     const groups: AsObjectHashMap<T> = {};
//     function dfs(node: KAryTreeNode<T>, name: string[]) {
//         const groupKey = groupBy(node);
//         groups[groupKey as string] = node as unknown as T
//         node.groupName = name.concat(node.glid)
//         for (const child of (node.data || [])) {
//             dfs(child, node.groupName);
//         }
//     }
//
//     dfs(root, []);
//     return groups;
// }

export const treeToHashMap = function <T extends Record<string, any>>(tree: any): AsObjectHashMap<T> {
    let hashMap: AsObjectHashMap<T> = {};

    let recursive = (node: any) => {

        let { nameGroup: copyNameGroup = [] } = node
        let nameGroup = [...copyNameGroup, node.glid]

        if (node.data) {
            node.data.forEach((children: any) => recursive({ ...children, nameGroup }))
            node.nameGroup = nameGroup
            hashMap[node.glid] = node
        } else {
            node.nameGroup = nameGroup
            hashMap[node.glid] = node
        }
    };
    recursive(tree);

    return hashMap;
}

export default treeToHashMap;